import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar.js";
import { Config } from "../../core/config/config.js";
import { DialogHelper } from "../../core/util/dialogHelper.js";
import { General } from "../../../siteManagement/general.js";
import { SheetEventType } from "../../../siteManagement/sheet.js";
import { Helper } from "../../core/util/helper.js";
import { Grid } from "../../core/components/grid.js";
import { EditWorkPackagePartApp, EditWorkPackagePartProps } from "./editWorkPackagePart.js";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js";
import { NotificationHelper } from "../../core/util/notificationHelper.js";
import { AssemblyGroupViewElement, getFilteredGridData, setOptions } from "../../baugruppen/assemblyGroupViewElements.js";
import { getArticlesToBeSavedAsAssembly } from "../../project/articlesToBeSavedAsAssembly.js";
import { LinkedType, PartRequirementsEntity, WorkPackageEntity } from "./workPackage.js";
import { Article } from "../../commonInterfaces.js";
import React from "react";

export class WorkPackagePartsGrid extends React.Component<WorkPackagePartsGridProps, WorkPackagePartsGridState>{
    private _gridData: PartRequirementsEntity[] = [];
    private _originalGridOptions: kendo.ui.GridOptions;
    private _gridOptions: kendo.ui.GridOptions;
    private _enabled: boolean;
    private searchSettings: { searchType?: string; displayPattern?: string; additionalParams?: string }
    private _pos: number = 0;

    private customButtonSettings: { machineAllocation?: boolean, unpackParts?: boolean, summarizeParts?: boolean };
    capaReq = [];
    taskMachinesDs: any[];


    constructor(props: WorkPackagePartsGridProps) {
        super(props);
        this.searchSettings = props.searchSettings;
        this._enabled = !props.disabled;
        this.customButtonSettings = { ...this.customButtonSettings, ...props.customButtonSettings };
        this._originalGridOptions = this.props.gridOptions;
        this._gridOptions = this.props.gridOptions;
        this.loadCapaReq(props.entity.CapacityRequirements);
        this.state = {
            gridData: [],
            enableUnpacked: false,
            enableMachineAllocationAndSummarizeParts: false,
            maschNrToFilter: props.entity.MaschNrToFilter,
            maschBezeichnung: this.getMaschbezeichnung(props.entity.MaschNrToFilter),
            summarized: false,
            onlyParents: false,
            gridDataFiltered: false
        };
        this.taskMachinesDs = props.taskMachines;
        this.setOptions(this.state.summarized, this.state.onlyParents);
    }

    private changeOptions = (newSummarized, newOnlyParents) => {
        //let customButtonSettings = {
        //    summarize: !newSummarized,
        //    unpack: !newSummarized
        //};;
        this.setOptions(newSummarized, newOnlyParents);

        let gridData = getFilteredGridData(newSummarized, newOnlyParents, this._gridData);
        this.setState({
            onlyParents: newOnlyParents,
            summarized: newSummarized,
            //materialCustomButtonSettings: customButtonSettings,
            gridData: gridData,
            gridDataFiltered: newOnlyParents || newSummarized
        });
    }

    private setOptions(summarized: boolean, onlyParents: boolean) {
        this._gridOptions = setOptions(summarized, onlyParents, this._originalGridOptions);
        let hideColumns: string[] = ["MaschBezeichnung", "LinkedType.Title", "CapacityRequirement"];
        hideColumns.forEach(p => {
            let column = this._gridOptions.columns.find(c => c.field === p);
            if (Helper.hasValue(column)) {
                column.hidden = summarized || onlyParents;
            }
        });
    }

    private getMaschbezeichnung = (maschNr: string) => {
        if (Helper.hasValue(maschNr)) {
            let index = this.taskMachinesDs.findIndex(f => f['Key'] === maschNr);
            return index > -1 ? this.taskMachinesDs[index]['Value'] : "";
        }
        return "";
    }

    private loadGridData = (data: PartRequirementsEntity[]) => {
        for (let i = 0; i < data.length; i++) {
            data[i].CapacityRequirement = this.props.entity.CapacityRequirements.find(f => f.Id == data[i].CapacityRequirementId)
            data[i].IsGuid = data[i].Id;
            data[i].Pos = this._pos;
            this._pos++;
        }
        if (Helper.hasValue(this.state.maschNrToFilter)) {
            data = data.filter(i => i.Maschnr === this.state.maschNrToFilter);
        }
        //this.setState({ gridData: data });
        this._getGridData(data);
    }

    loadCapaReq = (ds) => {
        this.capaReq.length = 0;
        this.capaReq.push({ Key: null, Value: '' });
        for (let i = 0; i < ds.length; i++) {
            this.capaReq.push({ Key: ds[i].Id, Value: ds[i].Bezeichnung?.length > 0 ? ds[i].Bezeichnung : ds[i].Vorname + '  ' + ds[i].Name });
        }
    }

    private _edit = async (dataItem: PartRequirementsEntity) => {
        await this._openPos(dataItem);
    }

    private _openPos = async (dataItem: PartRequirementsEntity = null) => {
        let metadata = await Helper.getMetaData("editWorkPackageParts");
        this._initCodeWindow(dataItem, metadata);
    }

    create = () => {
        let searchType = "Article";
        let displayPattern = "[[artikelnummer]]";
        let additionalParams = "";
        if (Helper.hasValue(this.searchSettings)) {
            searchType = Helper.getValueOrDefault(this.searchSettings.searchType, searchType);
            displayPattern = Helper.getValueOrDefault(this.searchSettings.displayPattern, displayPattern);
            additionalParams = Helper.hasValue(this.searchSettings.additionalParams) ? "&" + this.searchSettings.additionalParams : additionalParams;
        }

        let url = `DynamicSearch/Window/${searchType}?fullObject=true&multi=true&displayPattern=${displayPattern}${additionalParams}`;

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, { disableTabTitle: true });
        sheet.bind(SheetEventType.ItemsSelected, async (e: { data: Array<Article> }) => {
            if (Array.isArray(e.data)) {
                let partRequirementsEntities = this.props.entity.PartRequirements;
                for (let i = 0; i < e.data.length; i++) {
                    let newId = kendo.guid();
                    let partsGridEntity: PartRequirementsEntity = {
                        Id: newId,
                        Artikelnr: e.data[i].artnr,
                        Anzahl: 1,
                        Kosten: e.data[i].ekpreis,
                        Epreis: e.data[i].preis,
                        Gpreis: e.data[i].preis,
                        EkPreis: e.data[i].ekpreis,
                        Rabatt: 0,
                        Artikelnummer: e.data[i].artikelnummer,
                        Produkt: e.data[i].produkt,
                        Bezeichnung: e.data[i].bezeichnung,
                        Datum: new Date(),
                        Maschnr: Helper.getValueOrDefault(this.state.maschNrToFilter, ""),
                        MaschBezeichnung: Helper.getValueOrDefault(this.state.maschBezeichnung, ""),
                        CapacityRequirementId: "",
                        CapacityRequirement: null,
                        IsNew: true,
                        RecordRight: { CanRead: true, CanWrite: true },
                        IsWatchable: false,
                        IsWatched: false,
                        CanBeUnpacked: e.data[i].isassemblygroup,
                        IsUnpacked: false,
                        ParentArtikelnummer: null,
                        ParentBezeichnung: null,
                        Summarized: false,
                        IsGuid: newId,
                        Pos: this._pos,
                        LinkedTypeValue: Config.settings.globalLinkedType,
                        LinkedType: { Name: LinkedType[Config.settings.globalLinkedType], Title: Helper.getTranslation("Field.Enum.LinkedType." + LinkedType[Config.settings.globalLinkedType]), Value: Config.settings.globalLinkedType }
                    };
                    this._pos++;
                    partRequirementsEntities.push(partsGridEntity);
                }
                let newArticles = partRequirementsEntities.filter(w => w.IsNew);
                if (!await this.props.doSave())
                    return;

                const articlesToBeSavedAsAssembly = await getArticlesToBeSavedAsAssembly(newArticles);

                let savedArticles = this.props.entity.PartRequirements.filter(w => newArticles.findIndex(i => i.Artikelnr === w.Artikelnr && i.IsGuid === w.IsGuid) !== -1);
                let parents = savedArticles.filter(a => a.CanBeUnpacked && articlesToBeSavedAsAssembly.findIndex(i => i === a.Artikelnr) !== -1);
                let assemblyResultCode = 0;
                if (parents.length > 0) {
                    if (await this.props.doResolveParts(parents))
                        this.loadGridData(this.props.entity.PartRequirements);
                }
                if (assemblyResultCode === 0)
                    this.loadGridData(this.props.entity.PartRequirements)
            }
        });
    }

    private _initCodeWindow = (entity: PartRequirementsEntity, metaData: any) => {
        this.loadCapaReq(this.props.entity.CapacityRequirements);
        const entityCopy = JSON.parse(JSON.stringify(entity));
        const workPackagePartsProps: EditWorkPackagePartProps = {
            disabled: this.props.disabled,
            entity: entityCopy,
            metadata: metaData,
            context: {
                key1: "entity.Id",
                keyVal1: entity.Id,
                contextType: "editWorkPackageParts",
                parentContextType: this.props.contextType,
                parentId: this.props.entity.Id,
                dataSources: { taskMachinesDs: this.props.taskMachines, capacityReqDs: this.capaReq }
            },
            dataSources: {
                capacityReqDs: this.capaReq,
                taskMachinesDs: this.taskMachinesDs
            },
            isWindow: true,
            handleMenuSelect: null,
            enableMenuItem: null,
            handleCreateValidator: null,
            handleFieldChange: null,
            handleDataLoaded: null,
            onChange: null
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.SavedSuccessfully,
            (parts: PartRequirementsEntity) => {
                let item = Helper.getArrayItem(this.props.entity.PartRequirements, "Id", parts.Id);
                if (item == null) {
                    item = JSON.parse(JSON.stringify(parts));
                    this.props.entity.PartRequirements.push(item);
                } else {
                    item.Artikelnr = parts.Artikelnr;
                    item.Artikelnummer = parts.Artikelnummer;
                    item.Anzahl = parts.Anzahl;
                    item.Produkt = parts.Produkt;
                    item.Bezeichnung = parts.Bezeichnung;
                    item.Datum = parts.Datum;
                    item.EkPreis = parts.EkPreis;
                    item.Epreis = parts.Epreis;
                    item.Gpreis = parts.Gpreis;
                    item.Kosten = parts.Kosten;
                    item.Rabatt = parts.Rabatt;
                    item.Maschnr = parts.Maschnr;
                    item.Rechnungstext = parts.Rechnungstext;
                    item.Bemerkung = parts.Bemerkung;
                    item.MaschBezeichnung = parts.MaschBezeichnung;
                    item.CapacityRequirementId = parts.CapacityRequirementId;
                    item.CanBeUnpacked = parts.CanBeUnpacked;
                    item.IsUnpacked = parts.IsUnpacked;
                    item.ParentBezeichnung = parts.ParentBezeichnung;
                    item.ParentArtikelnummer = parts.ParentArtikelnummer;
                    item.IsGuid = parts.IsGuid;
                    item.Pos = parts.Pos
                    item.LinkedTypeValue = parts.LinkedTypeValue;
                    item.LinkedType = parts.LinkedType;
                    item.Changed = parts.Changed;
                    item.IndividualFields = parts.IndividualFields;
                    item.MaterialPriceDiscount = parts.MaterialPriceDiscount;
                    this.loadCapacityRequirement(item);
                }
                this.loadGridData(this.props.entity.PartRequirements);
                this.props.doUpdate(this.props.entity.PartRequirements);
            });

        sheet.show(() => {
            sheet.mountContent(EditWorkPackagePartApp, workPackagePartsProps);
        });
    }

    handleClickStandardButton = async (type: ToolBarStandardButtonType, dataItem: PartRequirementsEntity) => {
        if (type === ToolBarStandardButtonType.NEW) {
            let entity: PartRequirementsEntity = Helper.createEmptyEntity() as PartRequirementsEntity;
            entity.Id = kendo.guid();
            if (await this.props.doSave())
                this.create(); ////Öffnet Oberfläche für mehrere Artikel (Mehrfachauswahl)
        } else if (type === ToolBarStandardButtonType.EDIT) {
            if (!this._enabled || await this.props.doSave())
                await this._edit(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            if (await this.props.doSave())
                await this._deletePos(dataItem.Id);
        }
    }
    private _deletePos = async (id: string) => {
        let isOk = await DialogHelper.confirm(Config.translations.delete);
        if (isOk) {
            let item = Helper.findObjIndex(this.props.entity.PartRequirements, "Id", id);
            if (item >= 0) {
                this.props.entity.PartRequirements.splice(item, 1);
                this.loadGridData(this.props.entity.PartRequirements);
                this.props.doUpdate(this.props.entity.PartRequirements);
            }
        }
    }

    handleCustomButtonClick = async (id: string, dataItem: PartRequirementsEntity) => {
        if (id === "copy") {
            let entity: PartRequirementsEntity = JSON.parse(JSON.stringify(dataItem));
            entity.Id = kendo.guid();
            entity.IsNew = true;
            this.props.entity.PartRequirements.push(entity);
            this.loadGridData(this.props.entity.PartRequirements);
            this.props.doUpdate(this.props.entity.PartRequirements);
        }
        if (id === "auto_assignment") {
            let partsWihtoutMachine = this.props.entity.PartRequirements.filter(x => Helper.isNullOrEmpty(x.Maschnr));
            for (let part of partsWihtoutMachine) {
                let taskMachines = this.taskMachinesDs.filter(x => !Helper.isNullOrEmpty(x.Key));
                for (let machine of taskMachines) {
                    let entity: PartRequirementsEntity = JSON.parse(JSON.stringify(part));
                    if (Helper.isNullOrEmpty(part.Maschnr)) { //Vorhandene Artikel mit Maschine befüllen
                        part.Maschnr = machine.Key;
                        part.MaschBezeichnung = machine.Value;
                    }
                    else {
                        entity.Id = kendo.guid();
                        entity.IsNew = true;
                        entity.Maschnr = machine.Key;
                        entity.MaschBezeichnung = machine.Value;
                        this.props.entity.PartRequirements.push(entity);
                    }
                }
            }
            this.loadGridData(this.props.entity.PartRequirements);
            this.props.doUpdate(this.props.entity.PartRequirements);
        }
        if (id === "unpack") {
            // Kopf raus, Kinder rein
            let dataItems: PartRequirementsEntity[] = [];
            dataItems.push(dataItem);
            await this.UnpackAssemblyGroupParts(dataItems);
        }
        if (id === "summarize") {
            let result = await HTTPService.post<JsonResultClass<PartRequirementsEntity[]>>("WorkPackage/SummarizeParts", { parts: this.state.gridData });
            if (result.Code === 0) {
                if (result.Data) {
                    this.loadGridData(result.Data);
                    this.props.entity.PartRequirements.splice(0, this.props.entity.PartRequirements.length);
                    result.Data.forEach(p => this.props.entity.PartRequirements.push(p));
                    this.props.doUpdate(this.props.entity.PartRequirements);
                }
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private async UnpackAssemblyGroupParts(dataItems: PartRequirementsEntity[]) {
        if (await this.props.doSave()) {
            await this.props.doResolveParts(dataItems);
            this.loadGridData(this.props.entity.PartRequirements);
        }
    }

    private _getGridData = (Parts: PartRequirementsEntity[]) => {
        this._gridData = Parts;

        let filterGridData: PartRequirementsEntity[] = getFilteredGridData(this.state.summarized, this.state.onlyParents, this._gridData);

        this.setState({ gridData: filterGridData });
    }

    private loadCapacityRequirement(item: PartRequirementsEntity) {
        if (Helper.hasValue(item.CapacityRequirementId)) {
            item.CapacityRequirement = this.props.entity.CapacityRequirements.find(f => f.Id == item.CapacityRequirementId);
        }
        else {
            item.CapacityRequirement = null;
        }
    }

    componentDidUpdate(prevProps: WorkPackagePartsGridProps, prevState: WorkPackagePartsGridState) {
        if (this.props.entity.MaschNrToFilter !== this.state.maschNrToFilter) {
            this.setState({
                maschNrToFilter: this.props.entity.MaschNrToFilter,
                maschBezeichnung: this.getMaschbezeichnung(this.props.entity.MaschNrToFilter)
            }, () => this.loadGridData(this.props.entity.PartRequirements));
        }
    }

    componentDidMount() {
        this.loadGridData(this.props.entity.PartRequirements);
    }


    private selectionChange = (dataitem: PartRequirementsEntity) => {
        if (Helper.hasValue(dataitem))
            this.setEnableButtons(Helper.hasValue(dataitem.CanBeUnpacked) ? dataitem.CanBeUnpacked : false);
    }

    private setEnableButtons = (canBeUnpacked: boolean = false) => {
        this.setState({
            enableUnpacked: canBeUnpacked,
            enableMachineAllocationAndSummarizeParts: !Helper.hasValue(this.state.maschNrToFilter)
        });
    }
    private static showCustomButton(setting?: boolean) {
        return !Helper.hasValue(setting) || setting;
    }

    render() {
        const customButtons: Array<GridCustomToolBarButton> = [];
        const enableButtons = this._enabled;
        const enableEditButton = this._enabled;
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: enableButtons });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: enableEditButton ? Config.translations.editLabel : Helper.getTranslation("WebCRM.Tasks.WorkPackage.Show"), enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: enableButtons && !this.state.gridDataFiltered });
        customButtons.push({ autoEnabledOnRecordSelected: true, caption: Config.translations.copyLabel, enabled: enableButtons && !this.state.gridDataFiltered, iconClass: "k-i-redo", id: "copy" });
        if (WorkPackagePartsGrid.showCustomButton(this.customButtonSettings.machineAllocation))
            customButtons.push({ autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("WebCRM.Tasks.WorkPackage.MachineAllocation"), enabled: enableButtons && this.state.enableMachineAllocationAndSummarizeParts && !this.state.gridDataFiltered, iconClass: "k-i-redo", id: "auto_assignment" });
        if (WorkPackagePartsGrid.showCustomButton(this.customButtonSettings.unpackParts))
            customButtons.push({ autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("WebCRM.Tasks.WorkPackage.UnpackParts"), enabled: enableButtons && this.state.enableUnpacked && !this.state.gridDataFiltered, iconClass: "k-i-redo", id: "unpack" });
        //if (this.showCustomButton(this.customButtonSettings.summarizeParts))
        //	customButtons.push({ autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("WebCRM.Tasks.WorkPackage.SummarizeParts"], enabled: enableButtons && this.state.enableMachineAllocationAndSummarizeParts, iconClass: "k-i-redo", id: "summarize" });
        const content = <Grid data={this.state.gridData} options={this._gridOptions} id="workPackagePartsGrid"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} customButtons={customButtons} onClickCustomButton={this.handleCustomButtonClick} onSelectionChanged={this.selectionChange} />

        return (
            <div>
                <AssemblyGroupViewElement changeOptions={this.changeOptions} onlyParents={this.state.onlyParents} summarized={this.state.summarized} />
                {content}
            </div>
        );
    }
}

interface WorkPackagePartsGridState {
    gridData: PartRequirementsEntity[];
    enableUnpacked: boolean;
    enableMachineAllocationAndSummarizeParts: boolean;
    maschNrToFilter: string;
    maschBezeichnung: string;
    summarized: boolean;
    onlyParents: boolean;
    gridDataFiltered: boolean;
}

export interface WorkPackagePartsGridProps {
    disabled: boolean;
    gridOptions: {};
    searchSettings: {};
    customButtonSettings: {};
    taskMachines: [];
    contextType: string;
    entity: WorkPackageEntity;
    doUpdate: (value: PartRequirementsEntity[]) => void;
    doSave: () => Promise<boolean>;
    doResolveParts: (parents: PartRequirementsEntity[]) => Promise<boolean>;
}